module.exports = __webpack_public_path__ + "img/dodo.8e18b2f7.png";